import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import './_Layouts.scss';
import { _className } from '../../utils/tools.js';
class LinearLayout extends React.Component {
    layoutClass;
    constructor(props, layoutClass) {
        super(props);
        this.layoutClass = layoutClass;
    }
    render() {
        const { innerRef, ...props } = this.props;
        return _jsx("div", { ...props, ref: innerRef, className: _className(this.layoutClass, props.className), children: props.children });
    }
}
export class Grid extends React.Component {
    render() {
        const { innerRef, ...props } = this.props;
        return _jsx("div", { ...props, ref: innerRef, className: _className('ts-grid', props.className), children: props.children });
    }
}
export class LL_V_L extends LinearLayout {
    constructor(props) {
        super(props, 'll_v_l');
    }
}
export class LL_V_C extends LinearLayout {
    constructor(props) {
        super(props, 'll_v_c');
    }
}
export class LL_V_R extends LinearLayout {
    constructor(props) {
        super(props, 'll_v_r');
    }
}
export class LL_H_T extends LinearLayout {
    constructor(props) {
        super(props, 'll_h_t');
    }
}
export class LL_H_C extends LinearLayout {
    constructor(props) {
        super(props, 'll_h_c');
    }
}
export class LL_H_B extends LinearLayout {
    constructor(props) {
        super(props, 'll_h_b');
    }
}
export class LL_VH_C extends LinearLayout {
    constructor(props) {
        super(props, 'll_vh_c');
    }
}
//# sourceMappingURL=Layouts.js.map